import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Logo from "../../Assets/logos/logo.svg";
import PlayStoreIcon from "../../Assets/common/PlaystoreIcon.png";

const FallBack = () => {
  const location = useLocation();
  const [packageId, setPackageId] = useState("com.seetal");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("id") || "com.seetal";
    setPackageId(id);
  }, [location]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-center p-6">
      {/* Logo */}
      <img
        src={Logo} // replace with your app logo
        alt="App Logo"
        className="w-24 mb-6"
      />

      {/* Title */}
      <h1 className="text-3xl font-bold text-gray-800 mb-2">
        Don’t have an account?
      </h1>

      {/* Subtitle */}
      <p className="text-gray-600 mb-6">
        Install our app and get started today.
      </p>

      {/* CTA Button */}
      <a
        href={`https://play.google.com/store/apps/details?id=${packageId}`}
        className="px-6 py-3 bg-[#0a823c] text-white font-semibold rounded-lg shadow-md transition"
      >
        <span className="flex justify-center items-center">
          <img
            src={PlayStoreIcon}
            alt="Play Store"
            className="w-6 h-6 mr-2 self-center"
          />
          Get the App
        </span>
      </a>
    </div>
  );
};

export default FallBack;
